import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {fetchApplicationNames, getCustomerReportsLogDetails} from "../../../actions";
import CustomerReportsUsageLogs from "./customerReportsUsageLog";

const mapStateToProps = (state) => ({
    allCustomers: state.customer.list,
    applicationList: state.applicationName.list
});
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            getCustomerReportsLogDetails,
            fetchApplicationNames
        },
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerReportsUsageLogs);
